<template>
    <section class="auth-page">

        <!-- This div is used for style purpose -->
        <div></div>

        <form @submit.prevent="submitForm" type="POST" class="auth-page--form">
            <div class="step-1 auth-page--form" v-if="step === 1">
                <img class="auth-page--logo" src="@/assets/logo_dark.png" alt="XMLShopconnector" />

                <h3>{{ t('auth.register') }}</h3>

                <input
                    type="text"
                    v-model="firstname"
                    id="firstname"
                    :placeholder="$translate.text('general.contact.firstname')"
                />

                <input
                    type="text"
                    v-model="middlename"
                    id="middlename"
                    :placeholder="$translate.text('general.contact.middlename')"
                />

                <input
                    type="text"
                    v-model="lastname"
                    id="lastname"
                    :placeholder="$translate.text('general.contact.lastname')"
                />

                <input
                    type="email"
                    v-model="email"
                    id="email"
                    :placeholder="$translate.text('general.email')"
                />

                <input
                    type="password"
                    v-model="password"
                    id="password"
                    :placeholder="$translate.text('general.password')"
                />

                <input
                    type="password"
                    v-model="passwordRepeat"
                    id="passwordRepeat"
                    :placeholder="$translate.text('general.password_confirm')"
                />

                <div class="form-submit">
                    <div>
                    </div>
                    <button
                        type="button"
                        class="button button--rounded"
                        :disabled="submittingIsLoading"
                        @click="nextStep()"
                    >
                        <span v-if="!submittingIsLoading">
                            {{ t('general.register') }}
                        </span>
                        <div v-else class="lds-ellipsis"><div></div><div></div><div></div><div></div></div>
                    </button>
                </div>
            </div>

        </form>

        <router-link :to="{ name: 'Login' }">{{ t('auth.back_to_login') }}</router-link>
    </section>
</template>
<script>
import swal from 'sweetalert';

import { post } from '@/helpers/http';
import handleError from '@/helpers/error';

export default {
    name: 'RegisterPage',

    data() {
        return {
            step: 1,
            firstname: '',
            middlename: '',
            lastname: '',
            email: '',
            password: '',
            passwordRepeat: '',

            submittingIsLoading: false,
        };
    },

    methods: {

        nextStep() {
            if (this.step === 1) {
                if (this.firstname === '') {
                    return swal(this.$translate.text('alert.whoops.message.firstname.required'));
                }
                if (this.lastname === '') {
                    return swal(this.$translate.text('alert.whoops.message.firstname.required'));
                }
                if (!this.validateEmail(this.email)) {
                    return swal(this.$translate.text('alert.whoops.message.email.invalid'));
                }
                if (this.password.length >= 8) {
                    if (this.password === '' || (this.password !== this.passwordRepeat)) {
                        return swal(this.$translate.text('alert.whoops.message.password_required'));
                    }
                } else {
                    return swal(this.$translate.text('wachtwoord moet minimaal 8 karakters zijn'));
                }

                return this.submitForm();
            }

            this.step = this.step + 1;
        },

        validateEmail(email) {
            const re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return re.test(email);
        },

        submitForm() {
            this.submittingIsLoading = true;
            post({
                url: `${this.$API_URL}/api/auth/register/${this.$route.params.token}`,
                data: {
                    first_name: this.firstname,
                    last_name: this.lastname,
                    middle_name: this.middlename,
                    email: this.email,
                    password: this.password,
                    password_confirmation: this.passwordRepeat,
                },
            })
                .then((response) => {
                    // Created from admin invite.
                    if (response.status === 201) {
                        swal(this.$translate.text('general.account.created'));
                        this.$router.push('/login');
                    }
                })
                .catch((error) => {
                    handleError({
                        error,
                        message: this.$translate.text('alert.whoops'),
                    });
                });
        },
    },
};
</script>
<style lang="scss" scoped>
.auth-page {
    width: 100%;
    min-height: 100vh;
    background-color: $bluegrey;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;

    &--logo {
        width: 100%;
        height: auto;
        max-width: 400px;
        margin-bottom: 48px;
        margin: 0 auto;
    }

    &--form {
        padding: 20px;
        display: flex;
        flex-direction: column;
        width: 1024px;

        input {
            margin-bottom: 8px;
            border: 0;
            border-radius: 4px;
            height: 40px;
            text-align: center;
            font-size: 16px;
        }

        button {
            margin-top: 16px;
            width:100%;
        }

        h3, p {
            text-align: center;
        }

        h3 {
            font-size: 32px;
            margin-bottom: 16px;
        }

        p {
            margin-bottom: 16px;
        }
    }

    a {
        margin-bottom: 24px;
        color: $blue;
        text-decoration: none;

        &:hover {
            color: darken($blue, 10%);
        }
    }
}

.subscription {
    list-style: none;
    list-style-type: none;
    display: grid;
    grid-template-rows: 1fr;
    grid-template-columns: 1fr 1fr 1fr;
    margin: 0;
}

.lds-ellipsis,
.lds-ellipsis div {
    box-sizing: border-box;
}
.lds-ellipsis {
    display: inline-block;
    position: relative;
    width: 38.8px;
    height: 16.8px;
}
.lds-ellipsis div {
    position: absolute;
    //top: 33.33333px;
    top: 4.33333px;
    width: 8.33333px;
    height: 8.33333px;
    border-radius: 50%;
    background: currentColor;
    animation-timing-function: cubic-bezier(0, 1, 1, 0);
}
.lds-ellipsis div:nth-child(1) {
    left: 8px;
    animation: lds-ellipsis1 0.6s infinite;
}
.lds-ellipsis div:nth-child(2) {
    left: 8px;
    animation: lds-ellipsis2 0.6s infinite;
}
.lds-ellipsis div:nth-child(3) {
    left: 32px;
    animation: lds-ellipsis2 0.6s infinite;
}
.lds-ellipsis div:nth-child(4) {
    left: 56px;
    animation: lds-ellipsis3 0.6s infinite;
}
@keyframes lds-ellipsis1 {
    0% {
        transform: scale(0);
    }
    100% {
        transform: scale(1);
    }
}
@keyframes lds-ellipsis3 {
    0% {
        transform: scale(1);
    }
    100% {
        transform: scale(0);
    }
}
@keyframes lds-ellipsis2 {
    0% {
        transform: translate(0, 0);
    }
    100% {
        transform: translate(24px, 0);
    }
}
</style>
